import Layout from "../components/Layout";
import OwnerForm from "../components/OwnerForm";

const UpdateOwner = () => {
  return (
    <Layout>
      <h1 className="text-2xl font-semibold mb-3">
        Update Property Owner records
      </h1>
      <OwnerForm type="update" />
    </Layout>
  );
};

export default UpdateOwner;
